import { render, staticRenderFns } from "./CourtInputAssistance.vue?vue&type=template&id=cb73269e&scoped=true&"
import script from "./CourtInputAssistance.vue?vue&type=script&lang=js&"
export * from "./CourtInputAssistance.vue?vue&type=script&lang=js&"
import style0 from "./CourtInputAssistance.vue?vue&type=style&index=0&id=cb73269e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb73269e",
  null
  
)

export default component.exports